import request from '@/utils/request'

/**
 * 技师休假相关API
 */
let LeaveApi = {
  /**
   * 获取技师休假列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getList(data, errorback) {
    return request._post('/supplier/technician.leave/index', data, errorback);
  },
  /**
   * 添加技师休假
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  add(data, errorback) {
    return request._post('/supplier/technician.leave/add', data, errorback);
  },
  /**
   * 修改技师休假
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  edit(data, errorback) {
    return request._post('/supplier/technician.leave/edit', data, errorback);
  },
  /**
   * 删除技师休假
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  del(data, errorback) {
    return request._post('/supplier/technician.leave/delete', data, errorback);
  },
  /**
   * 获取技师休假详情
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  detail(data, errorback) {
    return request._post('/supplier/technician.leave/detail', data, errorback);
  },
  /**
   * 获取技师休假类型列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getLeaveTypes(data, errorback) {
    return request._post('/supplier/technician.leave/getLeaveTypes', data, errorback);
  },
  /**
   * 检查技师休假时间冲突
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  checkConflict(data, errorback) {
    return request._post('/supplier/technician.leave/checkConflict', data, errorback);
  }
}

export default LeaveApi;



// WEBPACK FOOTER //
// ./src/api/technician/leave.js